<template>
	<div class="headerBox">
		<header>
			<div class="logo">
				<img src="./img/logo.png">
				<div class="txt">
					<p>大救星救援平台</p>
					<p>DaJiuXing Assistance Platform</p>
				</div>
			</div>
			<div class="cmdCenter" v-if="cmdNavShow">
				<ul>
					<li><router-link to='/monitoring' :class='{active:navActive}'>{{langtrans().ajjjk[languageIndex]}}</router-link></li>
					<li><router-link to='/cmd_center' :class='{active:navActive1}'>{{langtrans().ajgl[languageIndex]}}</router-link></li>
				</ul>
			</div>
			<div class="setBox">
				<div class="lang" @mouseover="langShow=true" @mouseleave="langShow=false">
					<p>{{languageName}}</p>
					<div class="langList" v-show="langShow">
						<p @click="setLanguage(0)">中文</p>
						<p @click="setLanguage(1)">English</p>
					</div>
				</div>
				<div class="name" @mouseover="setShow=true" @mouseleave="setShow=false">
					<div class="list">
						<img src="./img/pic.png">
						<p>HI,{{languageIndex == 0?insti.name : insti.nameEn}}</p>
					</div>
					<div class="set" v-show="setShow">
						<div class="box">
							<img src="./img/pic.png">
							<div class="boxName">
								<p>HI,{{languageIndex == 0?insti.name : insti.nameEn}}</p>
								<small>{{statusName}}</small>
							</div>
						</div>
						<ul class="listBox">
							<li @mouseover="setShow1=true" @mouseleave="setShow1=false" v-show="langShow1">
								<img src="./img/set1.png" v-if="setShow1">
								<img src="./img/set.png" v-else>
								<p>{{langtrans().jgsz[languageIndex]}}</p>
							</li>
							<li @mouseover="setShow2=true" @mouseleave="setShow2=false" v-if="historyShow">
								<img src="./img/history1.png" v-if="setShow2">
								<img src="./img/history.png" v-else>
								<p><router-link :to='{name:urlPath}'>{{langtrans().lsaj[languageIndex]}}</router-link></p>
							</li>
							<li @mouseover="setShow3=true" @mouseleave="setShow3=false" v-if="statisticalShow">
								<img src="./img/tongji1.png" v-if="setShow3">
								<img src="./img/tongji.png" v-else>
								<p><router-link :to='{name:statistical}'>{{langtrans().ajtj[languageIndex]}}</router-link></p>
							</li>
							<!-- <li @mouseover="setShow5=true" @mouseleave="setShow5=false">
								<img src="./img/subuser1.png" v-if="setShow5">
								<img src="./img/subuser.png" v-else>
								<p><router-link :to='{name:"subuser"}'>{{langtrans().whzyh[languageIndex]}}</router-link></p>
							</li> -->
							<li @mouseover="setShow6=true" @mouseleave="setShow6=false" v-if="false">
								<img src="./img/subuser1.png" v-if="setShow6">
								<img src="./img/subuser.png" v-else>
								<p><router-link :to='{name:"phone"}'>{{langtrans().dhwh[languageIndex]}}</router-link></p>
							</li>
							<li @mouseover="setShow4=true" @mouseleave="setShow4=false">
								<img src="./img/money1.png" v-if="setShow4">
								<img src="./img/money.png" v-else>
								<p v-if="languageIndex == 0">{{langtrans().cwgl[languageIndex]}}<small>( {{langtrans().swktt[languageIndex]}} )</small></p>
								<p v-else>
								{{langtrans().cwgl[languageIndex]}}
								<small style="display: block;line-height: 25px;margin-top: -10px;">( {{langtrans().swktt[languageIndex]}} )</small>
								</p>
							</li>
						</ul>
						<p class="txt" @click="logoutFun">{{langtrans().tcajkz[languageIndex]}}</p>
					</div>
				</div>
			</div>
		</header>
		<Messagebox></Messagebox>
    <!-- v v-if="typeUserId == 4 || typeUserId == 5 || typeUserId == 1" -->
    <template>
      <div class="workBox" v-show="$store.state.workBtn">
        <workBench></workBench>
      </div>
    </template>
    <img v-show="lingdang" class="lingdang" src="./../../assets/img/lingdang.png" @click="$store.commit('workBtnFun',true)">
		<div class="imgBox" v-if="$store.state.workImgBox.status">
			<i class="el-icon-circle-close" @click="closeFun"></i>
			<img :src="$store.state.workImgBox.url" alt="图片">
		</div>
	</div>
</template>

<script>
	import langtrans from "./index.vue.trans.js";
	import { logout } from '@/views/axios/api.js';
	import Messagebox from "@/components/Tips_box/message_box";
	import workBench from "@/views/commonPage/workbench";
	export default{
		data (){
			return {
        typeUserId:JSON.parse(window.localStorage.getItem("insti")).type,
				langShow:false,
				setShow:false,
				setShow1:false,
				setShow2:false,
				setShow3:false,
				setShow4:false,
				setShow5:false,
				setShow6:false,
				status:['监管机构','指挥中心','救援公司'],
				statusName:'',
				langShow1:false,
				urlPath:'',
				statistical:'',
				languageName:'中文',
				cmdNavShow:false,
				navActive:false,
				navActive1:false,
				historyShow:false,
				statisticalShow:false,
				lingdang:false
			}
		},
		props:[
			'insti'
		],
		components:{
			Messagebox,
			workBench
		},

		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},
		mounted(){
			this.getPath()
			//设置语言
			if(JSON.parse(window.localStorage.getItem("language")) != undefined){
				this.$store.commit('languageFun',JSON.parse(window.localStorage.getItem("language")))
				if(JSON.parse(window.localStorage.getItem("language")) == 0){
					this.languageName='中文'
				}else{
					this.languageName='English'
				}
			}else{
				window.localStorage.setItem("language",JSON.stringify('0'));
          this.$store.commit('languageFun',0)
			}
		},
		methods:{
			langtrans(){
				return langtrans
			},
			getPath(){
				var routePath=this.$route.matched;
				if(routePath[0].path == '/regulator'){
					this.langShow1=false;
					this.statusName=this.status[0]
					this.urlPath='Finish2',
          this.historyShow=true
					this.statistical='statistical'
          this.statisticalShow=true
				}else if(routePath[0].path == '/cmd_center'){
					this.langShow1=false;
					this.statusName=this.status[1]
				}else if(routePath[0].path == '/commonPage'){
					if(this.languageIndex == 0){
						this.statusName=this.status[2]
					}else{
						this.statusName='Assistance agency'
					}
				}
				if(JSON.parse(window.localStorage.getItem("insti")).type == 1){
					this.cmdNavShow=true
				}
			},
			logoutFun(){
				logout()
				.then(res => {
					console.log(res)
					if(res.status == 200){
						window.localStorage.clear();
						window.localStorage.setItem("language",this.$store.state.language);

						this.$message({
						  showClose: true,
				          message: '注销成功！',
				          type: 'success'
				       });
				      this.$router.push({
				        name: "Index",
				        params: {
				          time: new Date().getTime()
				        }
				      });
              window.location.href='#/'
					}else{
						this.$message.error(res.statusText);
					}
				})
				.catch(err => {
					console.log(err)
				})
			},
			setLanguage(index){
				this.langShow=false;
				if(index == 0){
					this.languageName='中文'
				}else{
					this.languageName='English'
				}
				window.localStorage.setItem("language",index);
          this.$store.commit('languageFun',index)
			},
			closeFun(){
				this.$store.commit('workImgBoxFun',{url:'',status:false})
			},
		},
		watch:{
			languageIndex(){
				this.getPath()
			},
      '$store.state.workBtn'(){
        if(this.$store.state.workBtn){
          this.lingdang=false;
          this.$store.commit('websockListFun')
        }
      },
      '$store.state.websockList.length'(){
        if(this.$store.state.websockList.length != 0){
          if(!this.$store.state.workBtn){
            this.lingdang=true
          }
        }
      },
		}
	}
</script>

<style scoped="scoped">
	.headerBox{height: 70px;background-color: #333;}
	.headerBox header{width: 1200px;margin: 0 auto;height: 70px;}
	.logo{overflow: hidden;float: left;padding: 10px 0;}
	.logo img{height: 50px;float: left;}
	.logo .txt{float: left;color: white;font-size: 16px;margin-left: 20px;line-height: 1.5;margin-top: 5px;}
	.logo .txt p:last-child{font-size: 14px;}
	.setBox{float: right;width: 390px;color: white;font-size: 14px;height: 70px;}
	.setBox .lang{width: 110px;float: left;cursor: pointer;position: relative;padding: 10px 0;}
	.setBox .lang:hover{background-color: #212123;}
	.setBox .lang p{line-height: 50px;text-align: center;}
	.langList{background-color: #212123;text-align: center;position: absolute;top: 70px;left: 0;width: 110px;z-index: 10;}
	.langList p:hover{background-color: #00abfa;}
	.setBox .name{float: left;width: 260px;cursor: pointer;position: relative;padding: 10px 0;padding-left: 20px;}
	.setBox .name:hover{background-color: #212123;}
	.setBox .name .list{overflow: hidden;width: 100%;}
	.setBox .name .list p{float: left;line-height: 50px;margin-left: 10px;width: 180px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
	.setBox .name .list img{float: left;width: 50px;height: 50px;}
	.setBox .set{background-color: #212123;width: 280px;position: absolute;top: 70px;left: 0;z-index: 999;}
	.setBox .set .box{overflow: hidden;padding: 20px 0;border-bottom: 1px solid #333;margin: 0 30px;}
	.setBox .set .box img{float: left;height: 40px;width: 40px;}
	.setBox .set .box .boxName{float: left;width: 130px;text-align: left;padding-left: 5px;}
	.setBox .set .box .boxName p{overflow: hidden;text-overflow: ellipsis;white-space: nowrap;line-height: 1.5;}
	.setBox .set .box .boxName small{color: #999;}
	.listBox{border-bottom: 1px solid #333;margin: 0 20px;}
	.listBox li{overflow: hidden;line-height: 50px;padding-left: 30px;}
	.listBox li a{text-decoration: none;color: white;}
	.listBox li:hover{background-color: #00abfa;}
	.listBox li img{float: left;margin-top: 13px;}
	.listBox li p{float: left;margin-left: 10px;}
	.listBox li p small{color: #999;}
	.set .txt{padding: 20px 0;text-align: center;}
	.cmdCenter{float: left;margin-left: 100px;}
	.cmdCenter a{color: white;text-decoration: none;}
	.cmdCenter ul{overflow: hidden;}
	.cmdCenter ul li{float: left;margin-left: 20px;line-height: 70px;}
	.cmdCenter .router-link-active{color: #00abfa;}
	.cmdCenter a.active{color: #00abfa;}
	.workBox{position: fixed;width: 100%;top: 0;left: 0;height: 100vh;z-index: 2;}
	.imgBox{position: fixed;top: 0;left: 0;z-index: 10;text-align: center;background: rgba(0,0,0,0.5);width: 100%;height: 100vh;}
	.imgBox img{object-fit: contain;height: 100vh;}
	.el-icon-circle-close{position: absolute;top: 20px;right: 20px;z-index: 20;color: #409EFF;font-size: 30px;cursor: pointer;}
  .lingdang{position: fixed;bottom: 20px;right: 20px;width: 30px;animation:antzone 0.4s 0s infinite;-webkit-transform-origin:top;z-index: 8;}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue